import ExtendableError from '../lib/ExtendableError';
import _ from 'lodash';


function _getErrorMessage(errors = []) {
    const cocsError = (e) => e.code && `${e.code}: ${e.message}`;
    const jpError = (e) => e.failureType && `${e.failureType}: ${e.errorCode}`;

    const messages = [].concat(errors).map(
        (e) => !!e && (cocsError(e) || jpError(e))
    ).filter((message) => !!message);

    return messages.length ? messages.join(', ') : null;
}

export class ApiError extends ExtendableError {
    constructor (response, body, context) {
        const apiMessage = body && _getErrorMessage(body.errors);
        const httpError = response && response.statusText;
        super(apiMessage || httpError || 'Server Error', context);
        this.response = response;
        this.body = body;
    }
    name = 'ApiError';

    hasCode(code) {
        return _.findIndex(this.body.errors, ['code', code]) !== -1;
    }
}

export class RequestError extends ApiError {
    name = 'RequestError'
}

export class ServerError extends ApiError {
    name = 'ServerError'
}

export class UnauthorisedError extends ApiError {
    name = 'UnauthorisedError'
}

export class ForbiddenError extends ApiError {
    name = 'ForbiddenError'
}

export class NotFoundError extends RequestError {
    name = 'NotFoundError'
}

export class BadRequestError extends RequestError {
    name = 'BadRequest'
}



// WEBPACK FOOTER //
// ./src/errors/API.js